import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from 'mobily-ui-library';
import { GlobalContext } from '../../context/GlobalContext';

import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';

import './DeviceTerms.scss';

interface Props {
    handleHeaderCancel: () => void;
}

function DeviceTerms({ handleHeaderCancel }: Props) {
    const win: any = window;
    const serverURL = win['base_portal_url'];
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, selectedAcPlan, isInstallmentApplied, isSubsidyApplied, isFTIApplied } = state;
    const lang = rtl ? 'ar' : 'en';

    const { t } = useTranslation();

    const [checked, setChecked] = useState(false);
    const [htmlData, setHTMLData] = useState<any>(null);

    const acName = selectedAcPlan?.acName;

    useEffect(() => {
        let appleCareTermsUrl = '';

        if (win['env_variable'] === 'PROD') {
            appleCareTermsUrl = `${serverURL}/web/${lang}/devices/terms-and-conditions/coverage-subscription`;
        } else {
            appleCareTermsUrl = `${serverURL}/wps/wcm/connect/${lang}/devices/terms-and-conditions/coverage-subscription`;
        }

        fetch(appleCareTermsUrl)
            .then((res) => {
                return res.text()
            }).then(data => {
                setHTMLData(data);
                setTimeout(() => {
                    if (selectedAcPlan?.acName.includes("AppleCare+ warranty one time")) {
                        setTimeout(() => {
                            const row: any = document.getElementById('yearly_block');
                            row!.style.display = 'block';

                            const yearly_amount: any = document.getElementById('yearly_payment');
                            const duration: any = document.getElementById('payment_duration');
                            yearly_amount!.innerHTML = ` ${selectedAcPlan?.price}`;
                            duration!.innerHTML = t("two_years_sub");
                        }, 0)
                    }


                    if (selectedAcPlan?.acName.includes("AppleCare+ warranty recurring")) {
                        setTimeout(() => {
                            const row: any = document.getElementById('monthly_block');
                            row!.style.display = 'block';

                            const monthly_installment: any = document.getElementById('monthly_installment');
                            monthly_installment!.innerHTML = ` ${selectedAcPlan?.price}`;
                        }, 0)
                    }
                }, 0)
            })
    }, [])

    const handleCheckbox = () => {
        setChecked(prevState => !prevState)
    }

    const handleBackArrow = () => {
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "cartPage" } })
    }

    const handleAddCoverage = () => {
        if (acName.includes("AppleCare+ warranty recurring")) {
            dispatch({ type: "LOADER", payload: { loading: true } });
            dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "TermsOTP" } });
        } else {
            if (isInstallmentApplied || isSubsidyApplied || isFTIApplied) {
                dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "TermsOTP" } });
            } else {
                dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "TwoYearCoverageLogin" } });
            }
        }
    }

    return (
        <div className='DeviceTermsNCondition__Container'>
            <HeaderNavigation
                rtl={rtl}
                percent={100}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />

            <div className='DeviceTnC__Content' dangerouslySetInnerHTML={{ __html: htmlData ? htmlData : '' }}></div>

            {/* sticky terms n condition */}
            <div className='DTNC__StickyBox'>
                <div className='STB__Container_terms_ac'>
                    <div className='STB__TnC'>
                        <input aria-label='checkbox' type='checkbox' onChange={handleCheckbox} className='STB__Checkbox' />
                        <Typography rtl={rtl} id="lineType-heading" className='STB__Text'>{t('Accept_TermsNcondition')}</Typography>
                    </div>
                    <Button
                        rtl={rtl}
                        className={`STB__ApplyBtn ApplyBtn_sub`}
                        variant={!checked ? 'disabled' : 'default'}
                        onClick={handleAddCoverage}
                    >
                        {t('Add_coverage')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default DeviceTerms